module.exports = __webpack_public_path__ + "img/uk-1940s.397299c0.png";